import React, { ReactNode } from 'react';
import styles from './styles.module.css';

export default function BannerCta({
  children,
  className = '',
  showGlow = true,
  glowClass = '',
}: {
  children?: ReactNode;
  className?: string;
  showGlow?: boolean;
  glowClass?: string;
}) {
  return (
    <div className={`${styles.total} ${showGlow && 'relative'} ${className}`}>
      {showGlow && <div className={`${styles.totalGlow} ${glowClass}`} />}
      {children}
    </div>
  );
}
